export const initialState = {
  actionProcessing: false,
  usersList: { users: [] },
  newPassword: '',
};